export const SLIDER_SETTINGS = {
    slidesToShow: 2,
    slidesToScroll: 1,
    infinite: false,
    arrow: false,
    dots: true,
    autoplay: false,
    useTransform: false
};
